/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CarePlanFollowUpDurationUnit } from "./CarePlanFollowUpDurationUnit";

export interface CarePlanFollowUp {
  duration_unit: CarePlanFollowUpDurationUnit;
  duration_value: number;
  message: string;
}
